import classNames from 'classnames';
import PropTypes from 'prop-types';

import style from './styles.module.scss';

const Renderer = ({ message, closeButtonLabel, dispatchSetSnackBar, snackBarIsActive }) => {
  return (
    <div className={classNames(style.component, { [style.isActive]: snackBarIsActive })}>
      <div className={style.message}>
        <p>{message}</p>
      </div>
      <div>
        <p onClick={dispatchSetSnackBar} className={style.close}>
          {closeButtonLabel}
        </p>
      </div>
    </div>
  );
};

Renderer.propTypes = {
  message: PropTypes.string.isRequired,
  closeButtonLabel: PropTypes.string.isRequired,
  dispatchSetSnackBar: PropTypes.func.isRequired,
  snackBarIsActive: PropTypes.bool.isRequired,
};

export default Renderer;
